import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class MarketSettingsIndexRoute extends Route {
  @service access;
  @service router;

  redirect() {
    if (this.access.hasPersonalSettingsTab) {
      this.router.transitionTo('market.settings.personal');
      return;
    }

    this.router.transitionTo('market.settings.reports', {
      queryParams: { ownReports: !this.access.isStaffUser },
    });
  }
}
